<a *ngIf="badgeUrl" href="{{ badgeUrl }}">
  <img class="img-fluid" src="{{ badgeUrl }}/badge" alt="cii-badge" />
</a>
